angular.module('gym.pos').controller('AddTaxRateModal', ["$scope", "$rootScope", "$modalInstance", "TaxRates", function($scope, $rootScope, $modalInstance, TaxRates) {
  $scope.taxRate = TaxRates.get('new').$object;
  $scope.currency_symbol = $rootScope.gym.currency_symbol;
  $scope.save = function() {
    return TaxRates.post($scope.taxRate).then(function(taxRate) {
      return $modalInstance.close(taxRate);
    }, function(response) {
      return angular.extend($scope.taxRate, response.data);
    });
  };
  return $scope.close = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
